
export const enum MontageAddressType {
  HOME_ADDRESS = 0,
  MAG_WERKSTATT = 1,
  CUSTOM_ADDRESS = 2
}

export function getMontageAddress(order:any) {
  if(Number.isFinite(order?.montage_loctype)) {
    return order.montage_loctype;
  }
  return null;
}
